/* 接口统一管理 */
import { post } from "jquery";
import { Get, POST, DELETE } from "./http";
// 接口 baseUrl 管理
let baseUrl = "";
let exclUrl = "";

let baseUrlMock = "/mock_api"; // 模拟数据的根地址，自用
let exclUrlMock = "/mock_api";

if (process.env.NODE_ENV === "production") {
  // 测试环境 公司
  // baseUrl = "http://testzt.dtsum.com";
  // exclUrl = "http://testzt.dtsum.com";
  // baseUrl = "http://192.168.110.190:7776";
  // exclUrl = "http://192.168.110.190:7776";
  // 正式环境
  baseUrl = "https://aoyatec.com";
  exclUrl = "https://aoyatec.com";

  // 余成龙
  // baseUrl = 'http://192.168.110.12:7776';
  // exclUrl = 'http://192.168.110.12:7776';
  // baseUrl = 'http://192.168.110.200:7776';
  // exclUrl = 'http://192.168.110.200:7776';
} else if (process.env.NODE_ENV === "development") {
  baseUrl = "/api";
  exclUrl = "/api";
}
export default {
  exclUrl,
  baseUrl,

  exclUrlMock,
  baseUrlMock,

  /* 登录部分开始 */
  // 登录接口
  loginUser(params) {
    return Get(`${baseUrl}/iext/back/organization/LoginController/login`, params);
  },
  // 刷卡登录接口
  loginByCard(params) {
    return Get(`${baseUrl}/iext/back/organization/LoginController/loginByCard`, params);
  },
  // 验证码刷新
  loginRandomImage(params) {
    return Get(`${baseUrl}/iext/back/organization/LoginController/randomImage`, params);
  },
  // 退出登录
  loginOut() {
    return Get(`${baseUrl}/iext/back/organization/LoginController/loginOut`);
  },
  /* 登录部分结束 */
  // 修改密码
  editPd(params) {
    return POST(
      `${baseUrl}/iext/back/organization/UserManagerController/changePwd`,
      params
    );
  },
  /* 后台部分开始 */
  // 设备管理列表
  devicelist(params) {
    return Get(`${baseUrl}/iext/back/DeviceManagerController/devicelist`, params);
  },
  // 设备管理详情
  deviceInfo(params) {
    return Get(`${baseUrl}/iext/back/DeviceManagerController/info`, params);
  },
  // 新建设备
  addDevice(params) {
    return Get(`${baseUrl}/iext/back/DeviceManagerController/add`, params);
  },
  // 新增设备组
  addMachineGroup(params) {
    return Get(`${baseUrl}/iext/back/device/DeviceController/addDeviceGroup`, params);
  },
  // 修改设备状态设备
  changeDeviceStatus(params) {
    return Get(`${baseUrl}/iext/back/DeviceManagerController/change`, params);
  },
  // 删除设备维修日志
  repairDelLog(params) {
    return Get(`${baseUrl}//iext/back/DeviceManagerController/delLog`, params);
  },
  /* 系统管理 开始 */
  // 组织架构 树形结构 数据
  department() {
    return Get(
      `${baseUrl}/iext/back/organization/DepartmentManagerController/department`
    );
  },
  // 重置密码
  resetPassWord(params) {
    return Get(
      `${baseUrl}/iext/back/organization/UserManagerController/resetPassword`,
      params
    );
  },
  // 新增组织架构
  addDepartment(params) {
    return Get(
      `${baseUrl}/iext/back/organization/DepartmentManagerController/addDepartment`,
      params
    );
  },
  // 修改部门名称
  editName(params) {
    return Get(
      `${baseUrl}/iext/back/organization/DepartmentManagerController/editName`,
      params
    );
  },
  // 删除部门
  deleteDep(params) {
    return Get(
      `${baseUrl}/iext/back/organization/DepartmentManagerController/delete`,
      params
    );
  },
  // 用于搜索的员工列表搜索的字段
  searchListChar() {
    return Get(`${baseUrl}/iext/back/organization/UserManagerController/searchList`);
  },
  // 用户列表
  userList(params) {
    return Get(
      `${baseUrl}/iext/back/organization/UserManagerController/userList`,
      params
    );
  },
  // 编辑某一个人的角色  组织架构
  editRoleByUser(params) {
    return Get(
      `${baseUrl}/iext/back/organization/UserManagerController/editUserRole`,
      params
    );
  },
  // 用于修改/搜索的角色列表
  searchRoleList() {
    return Get(`${baseUrl}/iext/back/organization/RoleManagerController/searchRoleList`);
  },
  // 用户导出接口
  exportUserList() {
    return Get(`${baseUrl}/iext/back/organization/UserManagerController/exportUserList`);
  },
  // 用于修改/搜索的部门列表
  searchSearchDEptList() {
    return Get(
      `${baseUrl}/iext/back/organization/DepartmentManagerController/searchSearchDeptList`
    );
  },
  // 修改角色 部门 备注
  editUser(params) {
    return Get(
      `${baseUrl}/iext/back/organization/UserManagerController/editUser`,
      params
    );
  },
  // 禁用员工
  abandonUser(params) {
    return Get(
      `${baseUrl}/iext/back/organization/UserManagerController/abandonUser`,
      params
    );
  },
  // 角色列表
  roleList(params) {
    return Get(
      `${baseUrl}/iext/back/organization/RoleManagerController/roleList`,
      params
    );
  },
  // 新建角色
  newRole(params) {
    return POST(
      `${baseUrl}/iext/back/organization/RoleManagerController/newRole`,
      params
    );
  },
  // 编辑角色
  editRole(params) {
    return Get(
      `${baseUrl}/iext/back/organization/RoleManagerController/editRole`,
      params
    );
  },
  // 角色详情
  roleDetail(params) {
    return Get(
      `${baseUrl}/iext/back/organization/RoleManagerController/roleDetail`,
      params
    );
  },
  // 新建角色时权限功能列表
  authorityList() {
    return Get(`${baseUrl}/iext/back/organization/RoleManagerController/authorityList`);
  },
  // 删除角色
  deleteRole(params) {
    return Get(
      `${baseUrl}/iext/back/organization/RoleManagerController/deleteRole`,
      params
    );
  },
  //料箱管理
  getMaterialBoxList() {
    return Get(`${baseUrl}/iext/back/box/boxController/materialBoxList`, params);
  },
  //料箱型号管理
  getMaterialBoxModelList() {
    return Get(`${baseUrl}/iext/back/box/boxController/boxModelList`, params);
  },
  /* 系统管理 结束 */

  /* 生产工单 开始 */
  // 工单列表
  selectList(params) {
    return Get(`${baseUrl}/iext/back/order/ProductOrderController/selectList`, params);
  },
  // 整经计划列表
  wrapPlanList(params) {
    return Get(`${baseUrl}/iext/back/warp/WarpPlanController/selectWorkOrder`, params);
  },
  // 整经计划列表点击开单
  wrapPlanKaidan(params) {
    return Get(`${baseUrl}/iext/back/warp/WarpPlanController/selectMaterial`, params);
  },
  // 整经计划详情页
  wrapPlanDetails(params) {
    return Get(`${baseUrl}/iext/back/warp/WarpPlanController/getWarpTaskDetails`, params);
  },
  // 打印接口
  updateWarpPrint(params) {
    return Get(`${baseUrl}/iext/back/warp/WarpPlanController/updateWarpPrint`, params);
  },
  // 派工列表
  dispatchList(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductExecuteController/reProductExecuteList`,
      params
    );
  },
  // 派工提交
  dispatchSubmit(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductExecuteController/productDispatch`,
      params
    );
  },
  // 量产派工提交
  outputDispatchSubmit(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductExecuteController/addAndEditMassDispatch`,
      params
    );
  },
  // 生产工单查询关键词列表
  searchWorkOrderList() {
    return Get(`${baseUrl}/iext/back/order/ProductOrderController/searchList`);
  },
  // 补单
  addOrder(params) {
    return Get(`${baseUrl}/iext/back/order/ProductOrderController/addOrder`, params);
  },
  // 生产工单详情
  selectListDetail(params) {
    return Get(`${baseUrl}/iext/back/order/ProductOrderController/selectById`, params);
  },
  // 修改预计产量
  changePredictOutput(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductOrderController/changePredictOutput`,
      params
    );
  },
  // 获取子工单详情
  getChildWorkOrder(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductOrderController/getChildWorkOrder`,
      params
    );
  },
  // 保存编辑后的子工单
  saveNewChildWorkOrder(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductOrderController/saveNewChildWorkOrder`,
      params
    );
  },
  // 删除子工单
  deleteChildWorkOrder(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductOrderController/deleteChildWorkOrder`,
      params
    );
  },
  // 同时删除多个子工单,智能拆分的时候
  deleteChildOrder(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductOrderController/workOrderSmartSplit`,
      params
    );
  },
  // 点击保存删除X号点击过的子工单
  deleteHandChildOrder(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductOrderController/deleteNewChildWorkOrder`,
      params
    );
  },
  // 判断工单是否可以拆分
  isProduct(params) {
    return Get(`${baseUrl}/iext/back/order/ProductOrderController/isProduct`, params);
  },
  // 显示哪些表头字段的提交
  setTitle(params) {
    return Get(`${baseUrl}/iext/back/organization/CommonController/editForm`, params);
  },
  /* 生产工单 结束 */

  /* 工单排产 开始 */
  // 排产详情列表
  pcList(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductPlanController/productPlanList`,
      params
    );
  },
  // 可搜索字段列表
  productPlanSearchChar() {
    return Get(`${baseUrl}/iext/back/order/ProductPlanController/searchList`);
  },
  // 下发排产
  sentDownWorkOrder(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductPlanController/sentDownWorkOrder`,
      params
    );
  },
  // 撤销下发
  resetSentDownWorkOrder(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductPlanController/resetSentDownWorkOrder`,
      params
    );
  },
  // 撤销排产
  resetProductPlan(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductPlanController/resetProductPlan`,
      params
    );
  },
  // 排产详情接口
  getPcInfo(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductPlanController/productPlanInfo`,
      params
    );
  },
  // 设备运行时状态提示接口
  pcDeviceStatus(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductPlanController/selectDeviceStatus`,
      params
    );
  },
  // 改机单续接单 打印字段接口
  changeMachineFrom(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductPlanController/changeMachineFrom`,
      params
    );
  },
  // 排产设备列表接口
  selectDeviceList(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductPlanController/selectDeviceList`,
      params
    );
  },
  // 保存和编辑排产信息接口
  savePcInfo(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductPlanController/saveProductPlanInfo`,
      params
    );
  },
  // 保存备注
  saveRemark(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductPlanController/updateProductPlanRemark`,
      params
    );
  },
  // 批量指定完工
  endMassProduction(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductExecuteController/batchEndMassProduction`,
      params
    );
  },
  // 排产可选状态列表接口

  /* 工单排产 结束 */

  /* 统计报表 开始 */
  // 生产报表
  // 生产报表查询关键字 列表
  excuteSearchKeys() {
    return Get(`${baseUrl}/iext/back/monitoring/ListController/excuteSearchKeys`);
  },
  // 生产报表 列表
  executeList(params) {
    return Get(`${baseUrl}/iext/back/monitoring/ListController/executeList`, params);
  },
  // 工时报表 列表
  manhourList(params) {
    return Get(`${baseUrl}/iext/back/monitoring/ListController/userWorkTimeList`, params);
  },
  // 设备利用偏差率报表
  // 设备列表
  rateDeviceList(params) {
    return Get(`${baseUrl}/iext/back/monitoring/ListController/deviceList`, params);
  },
  openTimesList(params) {
    return Get(`${baseUrl}/iext/back/monitoring/ListController/deviceOpenCount`, params);
  },
  // 穿纱改机人员报表
  // 可搜索字段
  totalSearchKeys() {
    return Get(`${baseUrl}/iext/back/monitoring/ListController/totalSearchKeys`);
  },
  // 列表 数据
  textlieTotalList(params) {
    return Get(`${baseUrl}/iext/back/monitoring/ListController/totalList`, params);
  },
  // 下机报表
  // 下机报表可搜索关键字 列表
  finishSearchKeys() {
    return Get(`${baseUrl}/iext/back/monitoring/ListController/finishSearchKeys`);
  },
  // 下机报表 报表
  finishList(params) {
    return Get(`${baseUrl}/iext/back/monitoring/ListController/finishList`, params);
  },
  //量产补卡
  cardSupply(params) {
    return Get(
      `${baseUrl}/iext/back/order/ProductExecuteController/cardSupplement`,
      params
    );
  },

  /* 统计报表 结束 */

  /* 工位电脑管理 开始 */
  // 设备列表
  padDeviceList(params) {
    return Get(`${baseUrl}/iext/back/pad/PadDeviceController/selectList`, params);
  },
  // 设备详情
  padDeviceInfo(params) {
    return Get(`${baseUrl}/iext/back/pad/PadDeviceController/selectInfo`, params);
  },
  // 删除设备
  deletePadDevice(params) {
    return Get(`${baseUrl}/iext/back/pad/PadDeviceController/delete`, params);
  },
  // 编辑平板信息
  padNameEdit(params) {
    return Get(`${baseUrl}/iext/back/pad/PadDeviceController/update`, params);
  },
  // 获取串口列表
  getSerialList(params) {
    return Get(`${baseUrl}/iext/back/pad/PadDeviceController/selectSerialList`, params);
  },
  // 获取子串口列表
  getChildSerialList(params) {
    return Get(
      `${baseUrl}/iext/back/pad/PadDeviceController/selectChildByParentId`,
      params
    );
  },
  // 获取串口详细信息
  selectDetailById(params) {
    return Get(`${baseUrl}/iext/back/pad/PadDeviceController/selectDetailById`, params);
  },
  // 新增串口
  insertSerial(params) {
    return Get(`${baseUrl}/iext/back/pad/PadDeviceController/insertSerial`, params);
  },
  // 编辑串口信息
  updateSerial(params) {
    return Get(`${baseUrl}/iext/back/pad/PadDeviceController/updateSerial`, params);
  },
  // 删除串口
  deleteSerial(params) {
    return Get(`${baseUrl}/iext/back/pad/PadDeviceController/deleteSerial`, params);
  },
  // 设备绑定机台号
  padBandDevice(params) {
    return Get(`${baseUrl}/iext/back/pad/PadDeviceController/padBandDevice`, params);
  },
  /* 工位电脑管理 结束 */
  /* 后台部分结束 */

  delectDev(params) {
    return POST(`${baseUrl}/iext/back/device/DeviceController/deleteDevice`, params);
  },
  scrapDev(params) {
    return POST(`${baseUrl}/iext/back/device/DeviceController/scrapDevice`, params);
  },
  addDev(params) {
    return POST(`${baseUrl}/iext/back/device/DeviceController/addDevice`, params);
  },
  // 删除保养单
  cancleMainten(params) {
    return POST(`${baseUrl}/iext/back/device/DeviceController/deleteMaintain`, params);
  },

  //工单看板获取穿纱列表
  getEntryListNew(params) {
    return Get(
      `${baseUrl}/iext/back/monitoring/WorkOrderMonitoringController/selectThredingOrChangeMachineNew`,
      params
    );
  },

  //获取平板端刷卡的卡号
  getIdCard(params) {
    return Get(
      `${baseUrl}/iext/back/pad/PadDeviceController/queryLastestCardCode`,
      params
    );
  },
  //获取车间平面图所对应车间
  getFormList(params) {
    return Get(`${baseUrl}/iext/back/device/DeviceController/workshoplist`, params);
  },
  // 下面写新pad端所对应接口
  // 编辑串口信息
  workshoplist(params) {
    return Get(`${baseUrl}/iext/back/device/DeviceController/workshoplist`, params);
  },
  // 获取工序列表
  processList(params) {
    return Get(`${baseUrl}/iext/back/device/DeviceController/processList`, params);
  },
  //下面为包纱管理页面接口
  //获取包纱工单数据
  getWrappedYarnList(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/getWrappedYarnList`,
      params
    );
  },
  //包纱工单-排产信息数据
  productionScheduling(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/productionSchedulingButton`,
      params
    );
  },
  //包纱工单-标准检测数据获取
  getInspectionStandards(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/getInspectionStandards`,
      params
    );
  },
  //生产执行报表数据获取
  productionExecutionReport(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/productionExecutionReport`,
      params
    );
  },
  //产量报表
  queryProductionReport(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/queryProductionReport`,
      params
    );
  },
  //生产跟踪数据
  queryProductTrack(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/queryProductTrack`,
      params
    );
  },
  //生产跟踪数据,机台工序单价表-展示
  getMachineProcessWages(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/getMachineProcessWages`,
      params
    );
  },
  //生产跟踪数据,获取机台号
  getMachineDevice(params) {
    return Get(`${baseUrl}/iext/back/order/YarnWrappingPlanController/getDevice`, params);
  },
  //生产跟踪数据,机台工序单价表-删除
  deleteMachineProcessWages(params) {
    return DELETE(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/deleteMachineProcessWages`,
      params
    );
  },

  //设备运行情况表展示
  getEquipmentOperationStatus(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/getEquipmentOperationStatus`,
      params
    );
  },

  //员工工时表数据
  queryEmployeeHours(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/queryEmployeeHours`,
      params
    );
  },
  //包纱管理自检首检报表数据
  inspectionReport(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/inspectionReport`,
      params
    );
  },
  //撤销完成
  inspectionrevoke(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/wrapYarnRevokeComplete`,
      params
    );
  },
  //工时删除
  timedelete(params) {
    return DELETE(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/deleteEmployeeHours`,
      params
    );
  },
  //检验删除
  inspectdelete(params) {
    return DELETE(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/deleteInspectionStandards`,
      params
    );
  },
  //机台改变
  updateDevice(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/updateDevice`,
      params
    );
  },
  //员工工资表数据
  getEmployeePayroll(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/getEmployeePayroll`,
      params
    );
  },
  //包纱管理
  closeOrOpenButton(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/closeOrOpenButton`,
      params
    );
  },
  //员工工资表修改员工报工工时
  updateEmployeePayroll(params) {
    return POST(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/updateEmployeePayroll`,
      params
    );
  },
  //批量处理删除功能
  deleteExceptionHandle(params) {
    return Get(
      `${baseUrl}/iext/back/postProcess/ExceptionHandleController/deleteExceptionHandle`,
      params
    );
  },
  //工单废品率
  getOrderDevice(params) {
    return Get(
      `${baseUrl}/iext/back/postProcess/ExceptionHandleController/getOrderDevice`,
      params
    );
  },
  //新增班组
  addEquipmentTeam(params) {
    return Get(`${baseUrl}/iext/back/device/DeviceController/addEquipmentTeam`, params);
  },
  //工时删除
  yieldDelete(params) {
    return POST(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/deleteProductionReport`,
      params
    );
  },
  //生产跟踪报表-删除
  deleteQueryProductTrack(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/deleteQueryProductTrack`,
      params
    );
  },
  //班次时间-展示
  yarnWrappingShowShifts(params) {
    return Get(
      `${baseUrl}/iext/back/order/YarnWrappingPlanController/showShifts`,
      params
    );
  },
  //获取设备配置信息
  DeviceConfigList(params) {
    return Get(
      `${baseUrl}/iext/back/device/DeviceConfig/list`,
      params
    );
  },
  //设备配置信息同步
  synDeviceConfigList(params) {
    return Get(
      `${baseUrl}/iext/back/device/DeviceConfig/synDeviceConfigList`,
      params
    );
  },
  
};



// WEBPACK FOOTER //
// ./src/api/api.js